import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { isSetupOwed } from 'src/sections/onboarding/setup-steps';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

// Pages a seller may still open while setup is unfinished:
// - their account, so nobody is ever locked away from their own billing or profile
// - the Marketplaces page, because connecting is setup work, and it is where the marketplaces that
//   need shop details or their own app store are connected
const ALWAYS_REACHABLE = [paths.account.root, paths.management.stores];

/**
 * Keeps a new seller in guided setup until they finish it or leave it themselves.
 *
 * Sits inside AuthGuard, so by the time this runs the seller is signed in and subscribed. Existing
 * sellers are marked as finished by migration 033 and never see this.
 */
export default function OnboardingGuard ({ children }) {
  const { user } = useAuthContext();
  const { pathname } = useLocation();

  const isReachableDuringSetup = ALWAYS_REACHABLE.some((path) => pathname.startsWith(path));

  if (isSetupOwed(user?.onboardingStatus) && !isReachableDuringSetup) {
    return <Navigate to={paths.setup} replace />;
  }

  return <>{children}</>;
}

OnboardingGuard.propTypes = {
  children: PropTypes.node,
};
